<template>
    <div>


        <!-- Start Services Details Area -->
		<section class="services-details-area ptb-80 mt-5">
			<div class="container">
				<div class="section-title">
                <h2>Mobile App Development</h2>
                <div class="bar"></div>
            </div>
				<div class="row align-items-center">
					<div class="col-lg-6 services-details">
						<div class="services-details-desc">
							<h3>Incredible Infrastructure</h3>
							<p>The best solution for a growing business is an app which will enhance your business to reach new heights. We here at a w b tech are are eager to help you with your own mobile app Android and IOS developers are highly experienced in making a responsive and productive app which can make your dreams come true with using all the latest technologies such as a MP unique API and a truckload of security and privacy protocols that makes your app secure. </p>

							
						</div>
					</div>

					<div class="col-lg-6 services-details-image">
						<img src="../../../../assets/img/services-details-image/1.png" class="wow fadeInUp" v-wow alt="image">
					</div>
				</div>

				<div class="separate"></div>

				<div class="row align-items-center">
					<div class="col-lg-6 services-details-image">
						<img src="../../../../assets/img/services-details-image/2.png" class="wow fadeInUp" v-wow alt="image">
					</div>

					<div class="col-lg-6 services-details">
						<div class="services-details-desc">
							<p>Our innovative UI design makes sure that you get more and more customers on your application.Our cross platform support is one of the best in the market which ensures that you reach your target audience without any hassle.Our highly reliable apps I will make sure that your audience will always have a clean experience when working with you with no glitches whatsoever.Our security solution is one of the biggest parts when making an app. At wB Tech we address and enhance industry specific security requirements from day one.</p>

							<div class="services-details-accordion">
								<VueFaqAccordion 
									:items="myItems"
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
        <!-- End Services Details Area -->
    </div>
</template>

<script>
import VueFaqAccordion from 'vue-faq-accordion';
export default {
	name: 'MobileAppDevelopment',
	components: {
        VueFaqAccordion
    },
    data() {
        return {
            text: `Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute.`,
           myItems: [
                {
                    title: 'Innovative Technology',
                    value: 'We leverage cutting-edge technology and methodologies to develop powerful sales automation software.'
                },
                {
                    title: 'Customer Partners',
                    value: 'We apply deep domain and hosting knowledge to support our clients’ technology and business goals.'
                },
                {
                    title: 'First-Rate Services',
                    value: 'We are committed to delivering best-in-class technology and customer service, building long lasting business partnerships.'
                }
            ]
        }
    }
}
</script>